import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '@core/state/app/app-state';
import { PhoneUtilService } from '@shared/services/phone-util.service';
import { InitAppAction } from '@core/state/app/app-actions';
import { IconService } from '@shared/elements/icon/icon.service';

@Injectable()
export class AppService {

    constructor(private store$: Store<IAppState>,
                private phoneUtilService: PhoneUtilService,
                private iconService: IconService
            ) {

    }

    initApp() {
        this.phoneUtilService.loadUpUtilities();
        this.store$.dispatch(new InitAppAction());
        this.iconService.fetchIcons();
    }
}